import { render, staticRenderFns } from "./AModal-contactoFeria.vue?vue&type=template&id=28aa6c17"
import script from "./AModal-contactoFeria.vue?vue&type=script&lang=js"
export * from "./AModal-contactoFeria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports